// Modules
import React from 'react'
import PropTypes from 'prop-types'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Icon.scss'

// Data (Local)
const icons = {
	automode: <path d="M12,10 C13.1045695,10 14,10.8954305 14,12 L14,16 C14,17.1045695 13.1045695,18 12,18 L8,18 C6.8954305,18 6,17.1045695 6,16 L6,12 C6,10.8954305 6.8954305,10 8,10 L12,10 Z M12,12 L8,12 L8,16 L12,16 L12,12 Z M12,6 C15.3137085,6 18,8.6862915 18,12 L18,15 L16,15 L16,12 C16,9.790861 14.209139,8 12,8 L9,8 L9,6 L12,6 Z" />,
	benchmark: <path d="M8.9287414,11 L8.9287414,17 L6.9287414,17 L6.9287414,11 L8.9287414,11 Z M12.9287414,7 L12.9287414,17 L10.9287414,17 L10.9287414,7 L12.9287414,7 Z M16.9287414,9.5 L16.9287414,17 L14.9287414,17 L14.9287414,9.5 L16.9287414,9.5 Z" />,
	dashboard: <path d="M16.9287414,7 C18.0333109,7 18.9287414,7.8954305 18.9287414,9 L18.9287414,15 C18.9287414,16.1045695 18.0333109,17 16.9287414,17 L6.9287414,17 C5.8241719,17 4.9287414,16.1045695 4.9287414,15 L4.9287414,9 C4.9287414,7.8954305 5.8241719,7 6.9287414,7 L16.9287414,7 Z M6.9287414,9 L6.9287414,15 L9.9287414,15 L9.9287414,9 L6.9287414,9 Z M11.9287414,15 L16.9287414,15 L16.9287414,9 L11.9287414,9 L11.9287414,15 Z" />,
	design: <path d="M14,10 L12,10 L12,9 L9,9 L9,11 L15,11 C16.1045695,11 17,11.8954305 17,13 L17,15 C17,16.1045695 16.1045695,17 15,17 L12,17 L12,18 L10,18 L10,14 L12,14 L12,15 L15,15 L15,13 L9,13 C7.9456382,13 7.08183488,12.1841222 7.00548574,11.1492623 L7,11 L7,9 C7,7.9456382 7.81587779,7.08183488 8.85073766,7.00548574 L9,7 L12,7 L12,6 L14,6 L14,10 Z" />,
	discover: <path d="M17.3033009,6.69669914 C20.232233,9.62563133 20.232233,14.3743687 17.3033009,17.3033009 L15.8890873,15.8890873 C18.0369709,13.7412037 18.0369709,10.2587963 15.8890873,8.1109127 L17.3033009,6.69669914 Z M6.69669914,6.69669914 L8.1109127,8.1109127 C5.9630291,10.2587963 5.9630291,13.7412037 8.1109127,15.8890873 L6.69669914,17.3033009 C3.76776695,14.3743687 3.76776695,9.62563133 6.69669914,6.69669914 Z M12,8.5 C13.9329966,8.5 15.5,10.0670034 15.5,12 C15.5,13.9329966 13.9329966,15.5 12,15.5 C10.0670034,15.5 8.5,13.9329966 8.5,12 C8.5,10.0670034 10.0670034,8.5 12,8.5 Z M12,10.5 C11.1715729,10.5 10.5,11.1715729 10.5,12 C10.5,12.8284271 11.1715729,13.5 12,13.5 C12.8284271,13.5 13.5,12.8284271 13.5,12 C13.5,11.1715729 12.8284271,10.5 12,10.5 Z" />,
	documents: <path d="M17,9 L7,9 L7,7 L17,7 L17,9 Z M17,13 L7,13 L7,11 L17,11 L17,13 Z M14,17 L7,17 L7,15 L14,15 L14,17 Z" />,
	feedback: <path d="M17.5,11.5 L15.5,11.5 C15.5,9.290861 13.709139,7.5 11.5,7.5 C9.290861,7.5 7.5,9.290861 7.5,11.5 C7.5,13.709139 9.290861,15.5 11.5,15.5 L11.5,17.5 C8.1862915,17.5 5.5,14.8137085 5.5,11.5 C5.5,8.1862915 8.1862915,5.5 11.5,5.5 C14.8137085,5.5 17.5,8.1862915 17.5,11.5 Z M19.5,17.5 L17.5,17.5 L17.5,19.5 L15.5,19.5 L15.5,17.5 L13.5,17.5 L13.5,15.5 L15.5,15.5 L15.5,13.5 L17.5,13.5 L17.5,15.5 L19.5,15.5 L19.5,17.5 Z" />,
	finetune: <path d="M10,10 L8,10 L8,14 L10,14 L10,16 L6,16 L6,8 L10,8 L10,10 Z M13,18 L11,18 L11,6 L13,6 L13,18 Z M14,16 L14,14 L16,14 L16,10 L14,10 L14,8 L18,8 L18,16 L14,16 Z" />,
	upload: <path d="M16.9497475,11.0502525 C18.1498272,12.2503323 18.9161875,13.8841315 18.9935327,15.6963545 L19,16 L19,17 L5,17 L5,16 C5,14.0670034 5.78350169,12.3170034 7.05025253,11.0502525 L8.46446609,12.4644661 C7.7840105,13.1449217 7.29877131,14.0205937 7.099964,15.0002666 L16.900036,15.0002666 C16.7012287,14.0205937 16.2159895,13.1449217 15.5355339,12.4644661 L16.9497475,11.0502525 Z M12,6 L15.5355339,9.53553391 L14.1213203,10.9497475 L13,9.829 L13,13 L11,13 L11,9.827 L9.87867966,10.9497475 L8.46446609,9.53553391 L12,6 Z" />
}
const monocolorItems = ['documents', /*'feedback', */'upload']

// Component: Brand > Icon
function Icon ({ className, name, pathColor, style, willScale }) {
	// Data
	// const { translate } = useLanguage('components.brand.icon')

	// Render
	if (!icons[name]) return null
	return (
		<span
			data-icon={name}
			data-brand="icon"
			className={
				'aix-icon' +
				(!!className ? ` ${className}` : '')
			}
			style={style}>
			<svg
				fill={pathColor || (monocolorItems.includes(name) ? 'var(--text-weak-color)' : `var(--product-${name}-color)`)}
				viewBox="0 0 24 24"
				className={willScale ? 'aix-scaled' : ''}>
				{icons[name]}
			</svg>
		</span>
	)
}

// Properties
Icon.propTypes = {
	className: PropTypes.string,
	name: PropTypes.string.isRequired,
	pathColor: PropTypes.string,
	style: PropTypes.object,
	willScale: PropTypes.bool
}
Icon.defaultProps = {
	willScale: false
}

// Export
export default Icon
